import { API_URL } from "../Config/index.js";
import { emitEvent } from "../MasterData/emitter";

// Helper function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("authToken");
  // return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.b7yzY4AJiJhlL4Ad3bUbtZhBEabYtcYgKXhFbTXjBX8"
};

const handleSessionTimeout = (status, data) => {
  if (status === 401 && data?.sessionTimeout) {
    emitEvent("session-timeout", data);
    return true;
  }
  return false;
};



// Upload Candidate CV (2-step: presign POST → PUT to S3)
// fileName is built as: {profileId}.{ext}  e.g. "e868d643.pdf"
export const uploadCandidateCV = async (file, profileId) => {
  try {
    const ext = file.name.split(".").pop();
    const fileName = `${profileId}.${ext}`;
    const fileType = file.type;

    // Step 1 — get presigned URL
    const presignRes = await fetch(`${API_URL}/candidate-cv-upload/upload/cv`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fileName, fileType }),
    });

    if (!presignRes.ok) {
      const errText = await presignRes.text();
      throw new Error(errText || `Failed to get upload URL: ${presignRes.status}`);
    }

    const presignData = await presignRes.json();
    if (!presignData.status || !presignData.data?.uploadUrl) {
      throw new Error(presignData.message || "Failed to get upload URL");
    }

    const { uploadUrl, s3Path } = presignData.data;

    // Step 2 — upload file to S3 presigned URL
    const uploadRes = await fetch(uploadUrl, {
      method: "PUT",
      body: file,
    });

    if (!uploadRes.ok) {
      throw new Error(`File upload to S3 failed: ${uploadRes.status}`);
    }

    return { success: true, s3Path };
  } catch (error) {
    console.error("Error uploading CV:", error);
    return {
      success: false,
      message: error.message || "File upload failed",
    };
  }
};

// Get Candidate Hires by Month API
export const getCandidateHires = async (monthYear) => {
  try {
    const authToken = getAuthToken();

    const response = await fetch(`${API_URL}/candidate-hire/${monthYear}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
    });

    const result = await response.json().catch(() => ({}));

     if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: null,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return {
        success: true,
        month: result.month,
        count: result.count,
        data: result.data || [],
      };
    } else {
      return {
        success: false,
        data: [],
        message: result.message || "Failed to fetch candidates",
      };
    }
  } catch (error) {
    console.error("Error fetching candidate hires:", error);
    return {
      success: false,
      data: [],
      message: error.message || "Network error occurred",
    };
  }
};

// Update Candidate Status API
export const updateCandidateStatus = async (payload) => {
  try {
    const authToken = getAuthToken();
    const response = await fetch(`${API_URL}/candidate-hire/editCandidate`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `${authToken}` } : {}),
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json().catch(() => ({}));
     if (handleSessionTimeout(response.status, result)) {
      return {
        success: false,
        data: null,
        message: result.uiMsg || result.message || "Session timeout",
      };
    }

    if (response.ok && result.status) {
      return { success: true, data: result.data, message: result.message || "Updated successfully" };
    } else {
      return { success: false, message: result.message || "Failed to update candidate" };
    }
  } catch (error) {
    console.error("Error updating candidate:", error);
    return { success: false, message: error.message || "Network error occurred" };
  }
};

// Submit Job Application API
export const submitJobApplication = async (payload) => {
  try {
    const response = await fetch(`${API_URL}/candidate-hire/applyJob`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(errText || `Server error: ${response.status}`);
    }

    const result = await response.json().catch(() => ({}));
    return {
      success: true,
      profileId: result.data?.profileId,
      data: result.data,
    };
  } catch (error) {
    console.error("Error submitting job application:", error);
    return {
      success: false,
      message: error.message || "Network error occurred",
    };
  }
};
